(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name adminCrewBatchers.factory:CrewBatchFactory
     *
     * @description
     *
     */
    angular
        .module('fuel')
        .factory('CrewBatchFactory', CrewBatchFactory);
    
    function CrewBatchFactory() {

        function SearchCriteriaDTO() {
            this.description = null;
            this.status = null;
			this.crewBatchCode = null;
            this.pageSize = null;
            this.startPosition = null;
        }
        

		function CrewBatchDTO() {
			this.crewBatchCode = null;
			this.description = null;
			this.status = null;
			this.statusCode = null;
			this.version = null;
		}
		
		function SaveCrewBatchDTO() {
			this.crewBatchCode = null;
			this.description = null;
			this.status = null;
			this.version = -1;
		}
        
        function FormattedCrewBatch(params) {
            var crewBatch =  new CrewBatchDTO();
            crewBatch.crewBatchCode = params.crewBatchCode;
            crewBatch.description = params.description;
            crewBatch.status = ( params.status == "INA" ) ? true : false ;
            crewBatch.statusCode = params.status;
           	crewBatch.version = params.version
            return crewBatch;
        }
        
        function GetNewCrewBatch(){
        	var crewBatch = new CrewBatchDTO();
        	crewBatch.version = -1;
        	crewBatch.statusCode = "INA";
        	crewBatch.status = true;
        	return crewBatch;
        }
        
        function GetCrewBatchSearchRequest() {
            return new SearchCriteriaDTO() ;
        }
        
        function FormattedCrewBatchCollection(crewBatchList){
        	var formattedList = [];
            angular.forEach(crewBatchList, function (crewBatch) {
                formattedList.push(FormattedCrewBatch(crewBatch))
            });
            return formattedList;
        }
        
        function PopulateCrewBatchSaveRequest(data) {
        	 var crewBatch =  new SaveCrewBatchDTO();
        	 crewBatch.crewBatchCode = data.crewBatchCode;
             crewBatch.description = data.description;
             crewBatch.status =  data.status ? "INA" : "ACT" ;
             crewBatch.version = data.version
             return crewBatch;
        }
        
        function PopulateCrewBatchDeleteRequest(data){
        	 var crewBatch =  new SaveCrewBatchDTO();
        	 crewBatch.crewBatchCode = data.crewBatchCode;
             crewBatch.version = data.version
             return crewBatch;
        }
        
        function FormatGridRowData(data){
        	var crewBatch =  new CrewBatchDTO();
        	crewBatch.crewBatchCode = data.crewBatchCode;
        	crewBatch.description = data.description;
        	crewBatch.status = data.status;
        	crewBatch.statusCode = data.statusCode;
        	crewBatch.version = data.version;
        	return crewBatch;
        }
        
        return {
              getCrewBatchSearchRequest: GetCrewBatchSearchRequest,
              formattedCrewBatchCollection: FormattedCrewBatchCollection,
              getNewCrewBatch : GetNewCrewBatch,
              populateSaveRequest : PopulateCrewBatchSaveRequest,
              populateCrewBatchDeleteRequest : PopulateCrewBatchDeleteRequest,
              formatGridRowData:FormatGridRowData
        }
    }
})();